<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h600_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div
              class="modal-row-box"
              style="padding-bottom:10px"
            >
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                    prop="cityId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.cityId"
                      filterable
                      clearable
                      placeholder="请选择城市"
                      style="width:100%"
                      @change="changeCityFun"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="区县"
                    prop="countyId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.countyId"
                      filterable
                      clearable
                      placeholder="请选择区县"
                      style="width:100%"
                      @change="changeCountyFun"
                    >
                      <el-option
                        v-for="item in countyOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="团购日期"
                    prop="purchaseDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.purchaseDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="团购场所类型"
                    prop="storeType"
                  >
                    <el-select
                      v-model="dialogAddEditForm.storeType"
                      placeholder="请选择团购场所类型"
                      style="width:100%"
                      @change="changeStoreTypeFun"
                    >
                      <el-option
                        v-for="item in storeTypeOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="团购场所"
                    prop="storeId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.storeId"
                      placeholder="请选择团购场所"
                      style="width:100%"
                      @change="changeStoreFun"
                    >
                      <el-option
                        v-for="item in storeOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="团购地址"
                    prop="address"
                  >
                    <el-input
                      v-model="dialogAddEditForm.address"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="团购人姓名"
                    prop="purchaserName"
                  >
                    <el-input
                      v-model="dialogAddEditForm.purchaserName"
                      placeholder="请输入团购人姓名"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="团购人性别">
                    <el-radio-group v-model="dialogAddEditForm.purchaserGender">
                      <el-radio
                        v-for="(item) in genderOptions"
                        :key="item.data"
                        :label="item.data"
                      >
                        {{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="团购人电话"
                    prop="purchaserPhone"
                  >
                    <el-input
                      v-model="dialogAddEditForm.purchaserPhone"
                      placeholder="请输入团购人电话"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="团购用途"
                    prop="purchaseUse"
                  >
                    <el-input
                      v-model="dialogAddEditForm.purchaseUse"
                      placeholder="请输入团购用途"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              团购明细
              <el-button
                type="success"
                style="float:right;margin-top:1px;margin-right:10px;"
                @click="handleAdd"
              >
                选择卷烟商品
              </el-button>
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="tobaccoListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="name"
                      label="名称"
                    />
                    <el-table-column
                      prop="unit"
                      label="单位"
                      width="80"
                    />
                    <el-table-column label="数量">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.amount"
                          @input="(val)=>{computedMathRow(val, scope.row, 'amount')}"
                          @blur="setNumberValueDefaultZero($event, scope.row, 'amount',2)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="单价">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.price"
                          @input="(val)=>{computedMathRow(val, scope.row, 'price')}"
                          @blur="setNumberValueDefaultZero($event, scope.row, 'price',2)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="合计">
                      <template slot-scope="scope">
                        {{ scope.row.total }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="90"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="danger"
                          size="mini"
                          @click="handleDeleteItem(scope.$index, 1)"
                        >
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              发放物料明细
              <el-button
                type="success"
                style="float:right;margin-top:1px;margin-right:10px;"
                @click="handleMaterialsAdd"
              >
                选择物料
              </el-button>
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="materialsName"
                      label="物料名称"
                    />
                    <el-table-column
                      prop="unitName"
                      label="单位"
                      width="80"
                    />
                    <el-table-column
                      label="数量"
                      width="120"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.amount"
                          @input="(val)=>{computedMathRow(val, scope.row, 'amount')}"
                          @blur="setNumberValueDefaultZero($event, scope.row, 'amount',2)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="90"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="danger"
                          size="mini"
                          @click="handleDeleteItem(scope.$index, 2)"
                        >
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              照片信息<span style="padding-left:30px;color:red">上传图片大小：小于10M; 格式：png、jpg、jpeg、gif</span>
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
    <!-- 物料列表 -->
    <material-list-dialog
      :dialog-visible.sync="dialogTobaccoVisible"
      dialog-title="卷烟商品信息"
      @selectedTobaccoFun="selectedTobaccoFun"
    />
    <!-- 物料列表 -->
    <visit-material-list-dialog
      :dialog-visible.sync="dialogMaterialVisible"
      :store-id="storeId"
      dialog-title="物料信息"
      @selectedMaterialsFun="selectedMaterialsFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 选择卷烟
import MaterialListDialog from './materialListDialog'
// 选择拜访物料
import VisitMaterialListDialog from './visitMaterialListDialog'
// 数据请求
import { getToken } from "@/utils/auth"
import { loadAreaDataApi } from '@/api/area'
import { findAttachmentInfoByConditionApi, deleteFileApi } from '@/api/common'
import { loadDictDataApi } from '@/api/dict'
import { getStoreListApi } from '@/api/store'
import { saveOrUpdateGroupPurchaseInfoApi, initGroupPurchaseInfoApi } from '@/api/groupPurchaseInfo'
export default {
  components: { MaterialListDialog, VisitMaterialListDialog },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      dialogAddEditForm: {
      },
      dialogAddEditFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
        countyId: [{ required: true, message: '请选择所属区县', trigger: 'change' }],
        purchaseDate: [{ required: true, message: '请选择团购时间', trigger: 'change' }],
        storeType: [{ required: true, message: '请选择场所类型', trigger: 'change' }],
        storeId: [{ required: true, message: '请选择团购场所', trigger: 'change' }],
        address: [{ required: true, message: '请输入团购地址', trigger: 'blur' }],
        purchaserName: [{ required: true, message: '请输入团购人姓名', trigger: 'blur' }],
        purchaserPhone: [{ required: true, message: '请输入团购人电话', trigger: 'blur' }],
        purchaseUse: [{ required: true, message: '请输入团购用途', trigger: 'blur' }],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }]
      },
      tobaccoListData: [],
      materialListData: [],
      provinceOptions: [],
      cityOptions: [],
      countyOptions: [],
      genderOptions: [],
      storeTypeOptions: [],
      storeOptions: [],
      dialogTobaccoVisible: false,
      dialogMaterialVisible: false,
      storeId: null,
      picData: { directory: 'groupPurchaseInfo' },
      picUploadAction: '',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
        this.provinceOptions = []
        this.cityOptions = []
        this.countyOptions = []
        this.genderOptions = []
        this.storeTypeOptions = []
        this.storeOptions = []
        this.picList = []
        this.initFileList = []
        this.dialogAddEditForm = {
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          countyId: '',
          countyName: '',
          purchaseDate: '',
          storeType: null,
          storeId: null,
          purchasePlace: '',
          address: '',
          purchaserName: '',
          purchaserGender: 1,
          purchaserPhone: '',
          purchaseUse: '',
          remark: ''
        }
        this.tobaccoListData = []
        this.materialListData = []
        this.storeId = null
        this.initStoreTypeData()
        this.initGenderSelectData()
        this.initProvinceSelectData()
        if (this.eventType !== 'add') {
          this.initData()
        }
      }
    }
  },
  methods: {
    getToken,
    // 初始省区下拉数据
    initProvinceSelectData() {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        if (this.eventType === 'add') this.loading = false
      })
    },
    // 选择省区回调
    changeProvinceFun(val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.dialogAddEditForm.cityName = ''
      this.dialogAddEditForm.cityId = null
      this.countyOptions = []
      this.dialogAddEditForm.countyName = ''
      this.dialogAddEditForm.countyId = null
      this.storeOptions = []
      this.dialogAddEditForm.storeId = null
      this.dialogAddEditForm.purchasePlace = ''
      this.dialogAddEditForm.address = ''
      this.initCitySelectData(val)
    },
    // 初始城市下拉数据
    initCitySelectData(val) {
      loadAreaDataApi({ parentId: val, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun(val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.cityName = selectItem ? selectItem.label : ''
      this.countyOptions = []
      this.dialogAddEditForm.countyName = ''
      this.dialogAddEditForm.countyId = null
      this.storeOptions = []
      this.dialogAddEditForm.storeId = null
      this.dialogAddEditForm.purchasePlace = ''
      this.dialogAddEditForm.address = ''
      this.initCountySelectData(val)
    },
    // 初始区县下拉数据
    initCountySelectData(val) {
      loadAreaDataApi({ parentId: val, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.countyOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择区县回调
    changeCountyFun(val) {
      let selectItem = {}
      selectItem = this.countyOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.countyName = selectItem ? selectItem.label : ''
      this.storeOptions = []
      this.dialogAddEditForm.storeId = null
      this.dialogAddEditForm.purchasePlace = ''
      this.dialogAddEditForm.address = ''
      if (this.dialogAddEditForm.storeType !== null && this.dialogAddEditForm.storeType !== '' && val !== null && val !== '') {
        this.initStoreData(this.dialogAddEditForm.storeType, val)
      }
    },
    // 初始形式下拉数据
    initGenderSelectData() {
      loadDictDataApi({ type: 15 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.genderOptions.push({ label: item.optionLable, data: item.optionValue })
        })
      })
    },
    // 初始终端类型
    initStoreTypeData() {
      loadDictDataApi({ type: 36 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.storeTypeOptions.push({ label: item.optionLable, data: Number(item.optionValue) })
        })
      })
    },
    // 选择终端类型
    changeStoreTypeFun(val) {
      this.storeOptions = []
      this.dialogAddEditForm.storeId = null
      this.dialogAddEditForm.purchasePlace = ''
      this.dialogAddEditForm.address = ''
      if (this.dialogAddEditForm.countyId !== null && this.dialogAddEditForm.countyId !== '' && val !== null && val !== '') {
        this.initStoreData(val, this.dialogAddEditForm.countyId)
      }
    },
    // 初始终端档案
    initStoreData(billType, countyId) {
      getStoreListApi({ isManager: '1', status: 1, billType: billType, countyId: countyId }).then(res => {
        const { data } = res
        data.forEach(item => {
          this.storeOptions.push({ label: item.storeName, data: item.id, address: item.address })
        })
      })
    },
    // 选择档案回调
    changeStoreFun(val) {
      let selectItem = {}
      selectItem = this.storeOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.purchasePlace = selectItem ? selectItem.label : ''
      this.dialogAddEditForm.address = selectItem ? selectItem.address : ''
    },
    // 添加卷烟
    handleAdd() {
      this.dialogTobaccoVisible = !this.dialogTobaccoVisible
    },
    // 添加物料
    handleMaterialsAdd() {
      if (this.dialogAddEditForm.storeId === null || this.dialogAddEditForm.storeId === '' || this.dialogAddEditForm.storeId === undefined) {
        this.$message({
          message: '请选择团购场所',
          type: 'warning'
        })
        return false
      }
      this.storeId = this.dialogAddEditForm.storeId
      this.dialogMaterialVisible = !this.dialogMaterialVisible
    },
    // 选择卷烟
    selectedTobaccoFun(selectData) {
      selectData.forEach(item => {
        let hasItem = false
        this.tobaccoListData.forEach(mItem => {
          if (mItem.tobaccoId === item.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          let pushItem = {
            tobaccoId: item.id,
            name: item.name,
            unit: item.unit,
            amount: 1,
            price: 0,
            total: 0
          }
          this.tobaccoListData.push(pushItem)
        }
      })
    },
    // 选择物料
    selectedMaterialsFun(selectData) {
      selectData.forEach(item => {
        let hasItem = false
        this.materialListData.forEach(mItem => {
          if (mItem.visitItemId === item.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          let pushItem = {
            visitItemId: item.id,
            schemeName: item.schemeName,
            schemeId: item.schemeId,
            schemeNo: item.schemeNo,
            materialsName: item.materialsName,
            materialsId: item.materialsId,
            sourceType: item.sourceType,
            unitName: item.unitName,
            unitId: item.unitId,
            amount: item.leftAmount,
            price: item.price,
            total: 0
          }
          this.materialListData.push(pushItem)
        }
      })
    },
    // 删除物料
    handleDeleteItem(index, type) {
      if (type === 1) {
        this.tobaccoListData.splice(index, 1)
      } else {
        this.materialListData.splice(index, 1)
      }
    },
    // 计算合计
    computedMathRow(val, obj, name) {
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
      obj['total'] = Number(obj['price']) * Number(obj['amount'])
    },
    // 图片上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过10MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    initData() {
      initGroupPurchaseInfoApi({ id: this.dataId }).then(res => {
        const { bill, detailList, materialsList } = res.data
        for (let key in this.dialogAddEditForm) {
          if (key !== 'purchaseDate') {
            this.dialogAddEditForm[key] = bill[key]
          }
        }
        this.dialogAddEditForm.purchaseDate = bill.purchaseDateStr
        this.dialogAddEditForm.id = bill.id
        this.tobaccoListData = detailList
        this.materialListData = materialsList
        this.initCitySelectData(bill.provinceId)
        this.initCountySelectData(bill.cityId)
        this.initStoreData(bill.storeType, bill.countyId)
        findAttachmentInfoByConditionApi({ sourceType: 3, sourceId: bill.id }).then(res1 => {
          if (res1.data && res1.data.length > 0) {
            res1.data.forEach(item => {
              let obj = {}
              obj.name = item.attachmentName
              obj.url = this.baseUrl + item.attachmentUrl
              obj.attachmentName = item.attachmentName
              obj.attachmentUrl = item.attachmentUrl
              this.picList.push(obj)
              this.initFileList.push(obj)
            })
          }
        })
        this.loading = false
      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          if (this.tobaccoListData.length > 0) {
            let isHasZero = false
            this.tobaccoListData.forEach(item => {
              if (Number(item.amount) === 0) {
                isHasZero = true
              }
            })
            if (isHasZero) {
              this.$message({
                message: '团购明细数量不能为0',
                type: 'warning'
              })
              return false
            }
          }
          if (this.materialListData.length > 0) {
            let isHasZero = false
            this.materialListData.forEach(item => {
              if (Number(item.amount) === 0) {
                isHasZero = true
              }
            })
            if (isHasZero) {
              this.$message({
                message: '发放物料明细数量不能为0',
                type: 'warning'
              })
              return false
            }
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '团购促销', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.operateButtonDisable = true
              this.loading = true
              this.loadingText = '正在处理数据中，请耐心等待'
              this.dialogAddEditForm.detailInfo = JSON.stringify(this.tobaccoListData)
              this.dialogAddEditForm.materialsInfo = JSON.stringify(this.materialListData)
              let picUrls = []
              let picNames = []
              this.picList.forEach(item => {
                picUrls.push(item.attachmentUrl)
                picNames.push(item.attachmentName)
              })
              this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
              this.dialogAddEditForm.picNames = JSON.stringify(picNames)
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    saveOrUpdate() {
      saveOrUpdateGroupPurchaseInfoApi(this.dialogAddEditForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
</style>
